// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/search/search_result.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_availability_window } from "../core/availability_window_pb";
import { file_proto_model_search_activity_result } from "./activity_result_pb";
import { file_proto_model_search_hotel_result } from "./hotel_result_pb";
import { file_proto_model_search_place_result } from "./place_result_pb";
import { file_proto_model_search_restaurant_result } from "./restaurant_result_pb";
import { file_proto_model_search_search_provider } from "./search_provider_pb";
import { file_proto_model_search_transportation_result } from "./transportation_result_pb";

/**
 * Describes the file proto/model/search/search_result.proto.
 */
export const file_proto_model_search_search_result = /*@__PURE__*/
  fileDesc("CiZwcm90by9tb2RlbC9zZWFyY2gvc2VhcmNoX3Jlc3VsdC5wcm90bxIGY2FybWVuIuoECgxTZWFyY2hSZXN1bHQSGAoQc2VhcmNoX3Jlc3VsdF9pZBgBIAEoCRIZChFzZWFyY2hfc2Vzc2lvbl9pZBgCIAEoCRIrCgdjcmVhdGVkGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBI4ChRhdmFpbGFiaWxpdHlfY2hlY2tlZBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASKwoHZXhwaXJlcxgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASKAoFc3RhdGUYBiABKA4yGS5jYXJtZW4uU2VhcmNoUmVzdWx0U3RhdGUSOAoUYXZhaWxhYmlsaXR5X3dpbmRvd3MYByADKAsyGi5jYXJtZW4uQXZhaWxhYmlsaXR5V2luZG93Ei0KC3Byb3ZpZGVyX2lkGAggASgLMhguY2FybWVuLlNlYXJjaFByb3ZpZGVySWQSFAoMcHJvdmlkZXJfdXJsGAkgASgJEioKCGFjdGl2aXR5GAogASgLMhYuY2FybWVuLkFjdGl2aXR5UmVzdWx0SAASJAoFaG90ZWwYCyABKAsyEy5jYXJtZW4uSG90ZWxSZXN1bHRIABIuCgpyZXN0YXVyYW50GAwgASgLMhguY2FybWVuLlJlc3RhdXJhbnRSZXN1bHRIABI2Cg50cmFuc3BvcnRhdGlvbhgNIAEoCzIcLmNhcm1lbi5UcmFuc3BvcnRhdGlvblJlc3VsdEgAEiQKBXBsYWNlGA4gASgLMhMuY2FybWVuLlBsYWNlUmVzdWx0SABCCAoGcmVzdWx0KtsBChFTZWFyY2hSZXN1bHRTdGF0ZRIjCh9TRUFSQ0hfUkVTVUxUX1NUQVRFX1VOU1BFQ0lGSUVEEAASHQoZU0VBUkNIX1JFU1VMVF9TVEFURV9GT1VORBABEiEKHVNFQVJDSF9SRVNVTFRfU1RBVEVfQVZBSUxBQkxFEAISHAoYU0VBUkNIX1JFU1VMVF9TVEFURV9IRUxEEAMSIAocU0VBUkNIX1JFU1VMVF9TVEFURV9TRUxFQ1RFRBAEEh8KG1NFQVJDSF9SRVNVTFRfU1RBVEVfRVhQSVJFRBAFQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM", [file_google_protobuf_timestamp, file_proto_model_core_availability_window, file_proto_model_search_activity_result, file_proto_model_search_hotel_result, file_proto_model_search_place_result, file_proto_model_search_restaurant_result, file_proto_model_search_search_provider, file_proto_model_search_transportation_result]);

/**
 * Describes the message carmen.SearchResult.
 * Use `create(SearchResultSchema)` to create a new message.
 */
export const SearchResultSchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_search_result, 0);

/**
 * Describes the enum carmen.SearchResultState.
 */
export const SearchResultStateSchema = /*@__PURE__*/
  enumDesc(file_proto_model_search_search_result, 0);

/**
 * Represents the state of a search result in the booking flow
 *
 * @generated from enum carmen.SearchResultState
 */
export const SearchResultState = /*@__PURE__*/
  tsEnum(SearchResultStateSchema);

